import React from 'react'

import { Box, Item, Text } from '@factorialco/deprecated-design-system'
import { A3innuvaContractsContractTypesFragment } from 'generated/resources/graphql'

import { AgreementDropdown } from 'modules/payroll_integrations_a3innuva/components/SettingsSteps/Agreement/AgreementDropdown'

interface AgreementItemProps {
  agreement: A3innuvaContractsContractTypesFragment
  selectedValue: string
  options: Item[]
  onSelect: (value: string, label: string) => void
}

export const AgreementItem: React.FC<AgreementItemProps> = ({
  agreement,
  selectedValue,
  options,
  onSelect,
}) => (
  <Box key={agreement.id} flexDirection="row" justifyContent="spaceBetween" maxWidth="s600">
    <Box paddingTop="s12" width="s300">
      <Text.Header3>{agreement.name}</Text.Header3>
    </Box>
    <Box width="s300">
      <AgreementDropdown
        name={`contract_type_${agreement.id}`}
        selectedValue={selectedValue}
        options={options}
        onSelect={onSelect}
      />
    </Box>
  </Box>
)
